import { siteConfig } from "../configuration/config";

export function isInWebView(): boolean {
  // Use siteConfig to determine if this is a mobile app
  return siteConfig.isMobileApp === "true";
}

export function isInWebViewLegacy(): boolean {
  try {
    if (typeof window === "undefined") return false;

    // React Native WebView injects this bridge
    if ((window as any).ReactNativeWebView) return true;

    // Mobile WebView flag from injected script
    if ((window as any).__TALKIO_WEBVIEW__) return true;

    // Explicit query flag support
    const params = new URLSearchParams(window.location.search);
    if (params.get("webview") === "true") return true;

    // Mobile app injected localStorage flag
    const fromLocalStorage = window.localStorage?.getItem("mobileAppAuthenticated") === "true";
    if (fromLocalStorage) return true;

    return false;
  } catch {
    return false;
  }
}

export function isInIframe(): boolean {
  try {
    if (typeof window === "undefined") return false;
    return window.self !== window.top;
  } catch {
    return false;
  }
}
